import { snakeToTitleCase } from '@domain-group/javascript-utils'

import { MediaLinkModel } from '@domain-group/realhub-backend-api-types'

export const linkTypes = [
  { key: 'facebook', title: 'Facebook' },
  { key: 'instagram', title: 'Instagram' },
  { key: 'interactive', title: 'Interactive' },
  { key: 'miniweb', title: 'Mini Web' },
  { key: 'reviews', title: 'Reviews' },
  { key: 'twitter', title: 'Twitter' },
  { key: 'video', title: 'Video' },
  { key: 'website', title: 'Website' },
  { key: 'other', title: 'Other' }, // 'other' sort out of order so appears at bottom of drop downs
]

export const getLinkTypeByKey = (key: string) => {
  const linkType = linkTypes.find(link => link.key === key)

  return linkType ? linkType.title : ''
}

export const getLinkCapitalizedTitle = (mediaLink: MediaLinkModel) => {
  const { label, link_type } = mediaLink

  if (!link_type) return ''
  if (link_type === 'other' && label) return label

  return snakeToTitleCase(link_type)
}
